(() => {
  const handle = value => String(value || '').trim().toLowerCase().replace(/^collection:/, '');
  const list = value => String(value || '').split('||').filter(Boolean);
  const node = value => window.hooniesCollectionNav?.nodes?.[handle(value)];
  const cache = new WeakMap();
  const facts = product => {
    if (product.dataset) {
      if (cache.has(product)) return cache.get(product);
      const d = product.dataset;
      let tags;
      try { tags = JSON.parse(d.productAllTags || 'null'); } catch { tags = null; }
      if (!Array.isArray(tags)) tags = [
        ...list(d.productTaxonomyAreas).map(v => 'dept:' + v),
        ...list(d.productTaxonomyCategories).map(v => 'cat:' + v),
        ...list(d.productTaxonomyTypes).map(v => 'type:' + v),
      ];
      const result = { id: String(d.productId || d.productGid || '').replace('gid://shopify/Product/', ''), tags: new Set(tags.map(handle)), vendor: handle(d.productVendor), title: handle(d.productTitle) };
      cache.set(product, result);
      return result;
    }
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(v => v.trim());
    return { id: String(product.id || '').replace('gid://shopify/Product/', ''), tags: new Set(tags.map(handle)), vendor: handle(product.vendor), title: handle(product.title) };
  };
  const combine = (values, mode) => mode === 'ANY' ? values.some(Boolean) : values.every(Boolean);
  const conditionMatches = (condition, product) => {
    const values = condition.values.map(value => {
      const expected = handle(value);
      if (condition.kind === 'tag') return product.tags.has(expected);
      if (condition.kind === 'vendor') return condition.relation === 'CONTAINS' ? product.vendor.includes(expected) : product.vendor === expected;
      if (condition.kind === 'title') return product.title !== expected;
      return false;
    });
    const result = combine(values, condition.mode);
    return condition.relation === 'NOT_TAGGED_WITH' ? !result : result;
  };
  const matchesNode = (current, product, seen) => {
    if (!current?.browse?.match || seen.has(current.id)) return false;
    seen.add(current.id);
    if (current.browse.match.sources.some(source => source.includeIds.includes(product.id)
      || (source.conditions.length && combine(source.conditions.map(condition => conditionMatches(condition, product)), source.mode)))) return true;
    return (current.hierarchy?.childIds || []).map(node)
      .filter(child => child?.visibility?.published && !child.browse?.legacy)
      .some(child => matchesNode(child, product, seen));
  };
  window.hooniesCommerceHierarchy = {
    supports: value => Boolean(node(value)?.browse?.match),
    matches: (value, product) => matchesNode(node(value), facts(product), new Set()),
    node,
  };
})();
